module.exports = __webpack_public_path__ + "img/bg00.3335388f.jpg";